import { render, staticRenderFns } from "./OrderReturn.vue?vue&type=template&id=e54a2d6a&scoped=true"
import script from "./OrderReturn.vue?vue&type=script&lang=js"
export * from "./OrderReturn.vue?vue&type=script&lang=js"
import style0 from "./OrderReturn.vue?vue&type=style&index=0&id=e54a2d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54a2d6a",
  null
  
)

export default component.exports